import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"#4285F4\" d=\"M5.108 18.187h2.584v-6.276L4 9.143v7.937c0 .613.497 1.107 1.108 1.107\"></path><path fill=\"#34A853\" d=\"M16.552 18.187h2.584c.613 0 1.107-.496 1.107-1.107V9.143l-3.691 2.768\"></path><path fill=\"#FBBC04\" d=\"M16.552 7.11v4.8l3.691-2.769V7.664c0-1.37-1.563-2.15-2.658-1.329\"></path><path fill=\"#EA4335\" d=\"M7.692 11.909v-4.8l4.43 3.323 4.43-3.323v4.8l-4.43 3.322\"></path><path fill=\"#C5221F\" d=\"M4 7.664v1.477l3.692 2.769v-4.8l-1.034-.775C5.562 5.514 4 6.295 4 7.665\"></path>", 5)
  ])))
}
export default { render: render }